const booleanToKey = (value: boolean) => {
  return value ? 'Yes' : 'No';
};
export default booleanToKey;
